module.exports = __webpack_public_path__ + "img/3.a6e3b8c2.jpg";